import { render, staticRenderFns } from "./input-cfpsid.vue?vue&type=template&id=1266b3bd"
import script from "./input-cfpsid.vue?vue&type=script&lang=js"
export * from "./input-cfpsid.vue?vue&type=script&lang=js"
import style0 from "./input-cfpsid.vue?vue&type=style&index=0&id=1266b3bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports